import React, { createContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get_user_action } from "../_redux/action";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [authenticated, setAuthenticated] = useState(false);
  const [userLoading, setUserLoading] = useState(false);
  const [officeInitialized, setOfficeInitialized] = useState(false);

  const { user, loggedIn } = useSelector((state) => state.get_user_reducer);

  useEffect(() => {
    const getUser = async () => {
      setUserLoading(true);
      await dispatch(get_user_action());
      setUserLoading(false);
    };
    getUser();
  }, [dispatch]);

  // Update authenticated state when authState changes
  useEffect(() => {
    setAuthenticated(loggedIn);
  }, [loggedIn]);

  return (
    <AuthContext.Provider
      value={{
        user,
        userLoading,
        officeInitialized,
        setOfficeInitialized,
        authenticated,
        setAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
